import React from "react";
import { DailyTaskDetailReportTableContent } from '../../../Common/Table/tableContent';
import tokenService from '../../../../Common/tokenDecoder';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const data = this.props.dataOne;
        const summarizedData = this.props.summarizedData;
        const totalCount = this.props.totalCount;
        const contentRowNames = this.props.rowNames;
        const keys = this.props.keys;

        return (
            <div>
                <h3><center><u>Sundry Factory Checklist Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Operation Entity: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.division == undefined ? "All Collection Points" : searchData.division}</div>
                    <div className="col"><b>Date: </b> {searchData.date}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>

                {keys.map((e, index) => {
                    return (
                        <div key={index} className="row pt-2">
                            <div className="col width4">

                                <table className="display dataTable no-footer" id={e}>
                                    <thead>
                                        <tr>
                                            <th>Collection Point</th>
                                            <th>Emp Name</th>
                                            <th>Emp Type</th>
                                            <th>Reg No</th>
                                            <th>Field</th>
                                            <th>Job Type</th>
                                            <th>Task</th>
                                            <th>Percentage(%)</th>
                                            <th>Start Time</th>
                                            <th>End Time</th>
                                            <th>Duration</th>
                                            <th>OT Hours</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <DailyTaskDetailReportTableContent
                                            data={data[e].map(row => ({
                                                ...row,
                                                jobTypeID: row.jobTypeID === 1 ? 'General' : row.jobTypeID === 2 ? 'Cash' : '-'
                                            }))}
                                            contentRowNames={contentRowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )
                })}
                <br></br>
                <div>
                    <h4><left><u>Field Summary</u></left></h4>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Total Summary
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Field Name
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Description
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Labour Count
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {summarizedData.map((row) => (
                                    <TableRow>
                                        <TableCell component="th" scope="row">
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                            {row.fieldName}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                        </TableCell>
                                        <TableCell component="th" scope="row" align={'right'}>
                                            {row.count}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <TableRow>
                                <TableCell colSpan={3} align={'center'} style={{ fontSize: '16px' }} ><b><strong>Total</strong></b></TableCell>
                                <TableCell align={'right'} style={{ fontWeight: "bold" }}>{totalCount}</TableCell>
                            </TableRow>
                        </Table>
                    </TableContainer>
                </div>
                <br></br>
                <br></br>
                <div>
                    <TableContainer component={Paper}>
                        <Table aria-label="simple table">
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Date
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Name
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Designation
                                    </TableCell>
                                    <TableCell align="center" style={{ fontWeight: "bold" }}>
                                        Signature
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {'Asst. Field Officer / Field Officer '}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {'Field Officer '}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {'Asst. Superintendent '}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                        {'Asst. Clerk - Data Operator '}
                                    </TableCell>
                                    <TableCell component="th" scope="row">
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
            </div>

        );
    }
}